import React from "react";
import { Link, useParams } from 'react-router-dom';
import TextInput from "~/shared/form/TextInput";
import ControlledForm from "~/shared/form/ControlledForm";
import FormResponse from "~/shared/form/FormResponse";
import FormButton from "~/shared/form/FormButton";
import PublicPage from "./PublicPage";

export default function SetNewPassword() {
    const { token } = useParams();

    async function onSubmit(data) {
        data.token = token;
    }

    return (
        <PublicPage title="Set New Password">
            <ControlledForm noAsterisk className="flex flex-col" onSubmit={onSubmit} post="auth/reset-password" success="Your password has been reset. You can now login with your new password." disableOnSuccess>
                <p className="text-neutral-600 mb-4">Enter a new password for your account below.</p>
                <div className="flex flex-col gap-4">
                    <TextInput label="Password" id="password" validate={(password, { confirm }) => password === confirm} invalid="Passwords must match." deps="confirm" placeholder="Enter new password" preset="password" required>
                        <span className="text-neutral-600 text-sm text-left mt-1">Password must be at least 8 characters long.</span>
                    </TextInput>
                    <TextInput label="Confirm Password" id="confirm" validate={(confirm, { password }) => password === confirm} invalid="Passwords must match." deps="password" placeholder="Confirm password" preset="password" required />
                </div>
                <FormResponse className="mt-4" />
                <div className="flex flex-col gap-4 items-center mt-6">
                    <FormButton submit formInput>Set Password</FormButton>
                    <Link to="/family-portal" className="red-link">Return to Login</Link>
                </div>
            </ControlledForm>
        </PublicPage>
    );
}
